export type IsoWeek = { year: number; week: number };
export type CalendarDayTarget = { view: "resourceTimeGridDay"; date: Date };

/** Deutsches Datum für Tooltip und Screenreader in der Jahresübersicht. */
export function formatYearOverviewDate(year: number, monthIndex: number, day: number): string {
  return `${String(day).padStart(2, "0")}.${String(monthIndex + 1).padStart(2, "0")}.${year}`;
}

/** Gültiges Navigationsziel eines Tages aus der Jahresübersicht. */
export function getYearOverviewDayTarget(year: number, monthIndex: number, day: number): CalendarDayTarget | null {
  if (!Number.isInteger(year) || monthIndex < 0 || monthIndex > 11 || !Number.isInteger(day)) return null;
  const maxDay = new Date(year, monthIndex + 1, 0).getDate();
  if (day < 1 || day > maxDay) return null;
  return { view: "resourceTimeGridDay", date: new Date(year, monthIndex, day) };
}

/** ISO-8601 calendar week for a local calendar date (Monday is first day). */
export function getIsoWeek(date: Date): IsoWeek {
  const utc = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const weekday = utc.getUTCDay() || 7;
  utc.setUTCDate(utc.getUTCDate() + 4 - weekday);
  const isoYear = utc.getUTCFullYear();
  const yearStart = new Date(Date.UTC(isoYear, 0, 1));
  return { year: isoYear, week: Math.ceil((((utc.getTime() - yearStart.getTime()) / 86_400_000) + 1) / 7) };
}

/** Number of ISO calendar weeks (52 or 53) in a year. */
export function getIsoWeeksInYear(year: number): number {
  return getIsoWeek(new Date(year, 11, 28)).week;
}

/** Local Monday of an ISO calendar week. */
export function getIsoWeekStart(year: number, week: number): Date {
  const jan4 = new Date(year, 0, 4);
  const daysSinceMonday = (jan4.getDay() + 6) % 7;
  const monday = new Date(year, 0, 4 - daysSinceMonday + (week - 1) * 7);
  return monday;
}
